import { useEffect, useState } from 'react';
import { classNames, profileName } from 'src/utilities';
import { Image } from '.';
import { useSelector } from 'react-redux';
import { generateColor } from '../../modules/SuperAdmin/components/pageComponents/SuperAdmin/Prompts/utils';

export const ProfileTopNavbar = ({
  base64Image = null,
  name = '? ?',
  className,
}) => {
  const { encounterList } = useSelector((state) => state?.encounterState);
  const { getAppointmentStatusList } = useSelector(
    (state) => state?.appointmentState
  );
  const { currentPractitioner } = useSelector(
    (state) => state?.practitionerState
  );
  const [appointmentwithColors, setappointmentwithColors] = useState({});
  const [imgError, setImgError] = useState(false);
  const loadedList =
    getAppointmentStatusList?.length > 0
      ? getAppointmentStatusList
      : encounterList?.length > 0
        ? encounterList
        : null;

  useEffect(() => {
    const newappointmentwithColors = { ...appointmentwithColors };
    if (loadedList?.length > 0) {
      loadedList?.forEach((appointment) => {
        const name = `${appointment?.practitioner_firstName ? appointment?.practitioner_firstName : appointment?.practitioner_first_name} ${
          appointment?.practitioner_lastName
            ? appointment?.practitioner_lastName
            : appointment?.practitioner_last_name
        }`;
        if (name && !newappointmentwithColors[name]) {
          const color = generateColor(name);
          newappointmentwithColors[name] = color;
        }
      });
    }
    setappointmentwithColors(newappointmentwithColors);
    // TODO: fixing the dependencies of this useeffect causes multiple rerenders
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    getAppointmentStatusList,
    encounterList,
    currentPractitioner,
    // appointmentwithColors,
    // loadedList,
  ]);

  let fullName = currentPractitioner.practitioner_name;
  let nameWithoutTitle = fullName.replace('Dr ', '');
  return (
    <>
      {base64Image && !imgError ? (
        <div
          className={classNames('profile-picture', className ? className : '')}
        >
          <Image
            className=""
            src={base64Image}
            alt="user"
            onError={() => setImgError(true)}
          />
        </div>
      ) : (
        <div
          className={classNames(
            'profile-picture-name flex justify-center items-center',
            className ? className : ''
          )}
          style={{
            background:
              appointmentwithColors[name] ||
              generateColor(nameWithoutTitle || ''),
          }}
        >
          {generateColor(nameWithoutTitle) && name && profileName(name)}
        </div>
      )}
    </>
  );
};
